(() => {
  if (window.ohBrandFacetNavigation) return;
  window.ohBrandFacetNavigation = true;
  let pending;

  document.addEventListener('dialog:after-hide', (event) => {
    const drawer = event.target;
    if (!(drawer instanceof HTMLElement) ||
        !drawer.matches('facets-drawer.og-catalogue-filters[id^="oh-brand-native-drawer-"]')) return;
    requestAnimationFrame(() => {
      if (drawer.hasAttribute('open')) return;
      const active = document.activeElement;
      if (active !== document.body && active !== drawer && !drawer.contains(active)) return;
      const button = [...document.querySelectorAll('.oh-brand__mfilter[aria-controls]')]
        .find(control => control.getAttribute('aria-controls') === drawer.id &&
          control.getClientRects().length > 0 && !control.closest('[inert]'));
      button?.focus({ preventScroll: true });
    });
  }, true);

  document.addEventListener('submit', (event) => {
    if (!document.querySelector('[data-oh-facet-navigation]')) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action$="/localization"]')) return;
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
  }, true);

  document.addEventListener('facet:update', (event) => {
    const sectionId = event.detail?.url?.searchParams?.get('section_id');
    const section = event.target.closest('.shopify-section') ||
      (sectionId && document.getElementById('shopify-section-' + sectionId));
    if (!section?.querySelector('[data-oh-facet-navigation]')) return;
    pending?.();
    const results = section.querySelector('#oh-brand-results');
    if (!results) return;
    const fromDrawer = !!event.target.closest('facets-drawer');
    let status = document.getElementById('oh-brand-facet-status');
    if (!status) {
      status = document.createElement('div');
      status.id = 'oh-brand-facet-status';
      status.className = 'sr-only';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      document.body.append(status);
    }
    status.textContent = '';
    let timer;
    const stop = () => {
      observer.disconnect();
      clearTimeout(timer);
      if (pending === stop) pending = undefined;
    };
    const observer = new MutationObserver(() => {
      if (section.contains(results)) return;
      stop();
      const button = section.querySelector('.oh-brand__mfilter');
      const active = document.activeElement;
      if (fromDrawer && button && getComputedStyle(button).display !== 'none' &&
          (active === document.body || !active?.isConnected)) {
        button.focus({ preventScroll: true });
      }
      status.textContent = section.querySelector('.oh-brand__count')?.textContent.trim() || '';
    });
    observer.observe(section, { childList: true });
    timer = setTimeout(stop, 15000);
    pending = stop;
  }, true);
})();
